<template>
  <ul class="imglist">
    <Game
      v-for="(item, i) in list"
      :key="item.game_id"
      :game="item"
      :index="i"
      :stat-params="statParams"
    />
  </ul>
</template>

<script>
import Game from './Game'
export default {
  components: {
    Game
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    statParams: {
      type: Object,
      required: false
    }
  }
}
</script>
